import { Component, Output, EventEmitter, inject } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-wrong-uuid',
  templateUrl: './nouuid-dialog.component.html',
  standalone: true,
  imports: [
    TranslocoPipe,
    FormsModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    CommonModule
  ],
})
export class wronguuidComponent {
  @Output() next = new EventEmitter<void>();
  email = '';
  public contactEmail: string = '';
  
  private translocoService = inject(TranslocoService);
  private _dialogRef = inject(MatDialogRef<wronguuidComponent>);
  private dialogUtilsService = inject(DialogUtilsService);
  
  constructor() {}
  ngOnInit(){
    //this.loadContactEmail();
  }

  private loadContactEmail(): void{
    try {
      const storedEmail = JSON.parse(localStorage.getItem('currentCountryInfo')).notifierMail;
      
      if (storedEmail) {
        this.contactEmail = storedEmail;
      }
    } catch (error) {
      console.error('Error loading contact email:', error);
    }
  }
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }

  continue() {
    if (this.email) this.next.emit();
  }
  closeDialog(): void {
    this.dialogUtilsService.closeDialog(this._dialogRef);
  }
  
  shouldShowCloseButton(): boolean {
    return true;
  }
}